function setActiveTab() {
  const currentPath = window.location.pathname;

  const tabs = document.querySelectorAll('.tab');

  tabs.forEach((tab) => {
    if (tab.getAttribute('href') === currentPath) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
    tab.addEventListener('click', function (event) {
      event.preventDefault();

      tabs.forEach((t) => t.classList.remove('active'));

      this.classList.add('active');

      window.location.href = this.href;
    });
  });
}

// TDOD: NEED TO MAKE HOOK for SULGIFY SCHEME NAME FURTHER
function standardizeToSlug(name) {
  if (typeof name !== 'string') return name;
  name = name.toLowerCase();
  const sanitizedSlug = name
    .replace(/[\s<>#%"{}\|\\^[\]()"`!_;/?:@&=+$,."]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .replace("'", '');

  return sanitizedSlug;
}

setActiveTab();
let currentPage = 2;
const viewmoreBtn = document.querySelectorAll('#view-more-btn');

const fetchNextDataRows = function () {
  if (apiURL) {
    const paginatedUrl = `${apiURL}&pagination=${currentPage}`;

    fetch(paginatedUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          appendDataRows(data.data);
          currentPage++;
        } else {
          viewmoreBtn.forEach((vmButton) => {
            vmButton.style.display = 'none';

            const noMoreFundsMsg = document.createElement('p');
            noMoreFundsMsg.textContent = 'No more Schemes available';
            noMoreFundsMsg.style.textAlign = 'center';
            noMoreFundsMsg.style.margin = '20px';

            vmButton.parentNode.appendChild(noMoreFundsMsg);
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }
};

const appendDataRows = function (records) {
  const tableBody = document.querySelector('table tbody');
  const mobileContent = document.querySelector('.mobile-content');
  records.forEach((record) => {
    const newRow = document.createElement('tr');

    const logoUrl = `http://torusapis.cmots.com/complogodata/mf/${record.mfCoCode}.png`;
    newRow.innerHTML = `
         <tr>
            <td class="first-td">
                <div class="text-img-part">
                    <div class="img-part">
                        <img
                            src="${logoUrl}"
                            alt="${record.modified_schName}" 
                            title="${record.modified_schName}" 
                            class="width--36"
                        />
                    </div>
                    <div class="text-part">
                        <a href="/mutual-funds/${standardizeToSlug(
                          record.modified_schName,
                        )}">${record.schName}</a>
                        <p>${record.category} | ${record.typename}</p>
                    </div>
                </div>
            </td>
            <td class="return">
                <span
                  data-one-year="${(record.oneYear || record.inception).toFixed(
                    2,
                  )}"
                  data-three-year="${(
                    record.threeYear || record.inception
                  ).toFixed(2)}"
                  data-five-year="${(
                    record.fiveYear || record.inception
                  ).toFixed(2)}"
                  style="color: ${record.oneYear > 0 ? '#05C098' : 'red'}">
                  ${(record.oneYear || record.inception).toFixed(2)}%
                </span>
            </td>
            <td>₹ ${record.minimumPurchaseAmount}</td>
            <td>₹ ${record.schemeAum.toFixed(2)}</td>
            <td><a href="/open-demat-account?query=mf&cta=invest" class="invest-btn">Invest</a></td>
          </tr>
        `;
    tableBody.appendChild(newRow);

    const mobileCard = document.createElement('div');
    mobileCard.classList.add('filter-card');
    mobileCard.innerHTML = `
            <div class="filter-top-card">
              <div class="card-img">
                <img
                  src="${logoUrl}"
                  alt="${record.modified_schName}"
                  title="${record.modified_schName}"
                  class="width--36"
                />
              </div>
              <div class="card-text">
              <a href="/mutual-funds/${standardizeToSlug(record.modified_schName)}">
                <h3>${record.schName}</h3>
              </a>
                <p class="card-text-type">
                  <span>${record.typename} <span> |
                  <span>${record.category} <span>
                </p>
              </div>
              <a href="/open-demat-account?query=mf&cta=invest">
              <button id="invest-btn-mobile-card" class="invest-btn">
              Invest
              </button>
              </a>
              </div>
            <div class="filter-bottom-card">
              <div class="return filter-bottom-card-first">
                <p>1Y returns</p>
                <span
                  data-one-year="${(record.oneYear || record.inception).toFixed(
                    2,
                  )}"
                  data-three-year="${(
                    record.threeYear || record.inception
                  ).toFixed(2)}"
                  data-five-year="${(
                    record.fiveYear || record.inception
                  ).toFixed(2)}"
                  style="color: ${record.oneYear > 0 ? '#05C098' : 'red'}">
                  ${(record.oneYear || record.inception).toFixed(2)}%
                </span>
              </div>
              <div class="filter-bottom-card-first">
                <p>Min. Invest</p>
                <h4>₹${record.minimumPurchaseAmount}</h4>
              </div>
              <div class="filter-bottom-card-first">
                <p>AUM</p>
                <h4>₹${record.schemeAum.toFixed(2)}</h4>
              </div>
            </div>
        `;

    mobileContent.appendChild(mobileCard);
  });
};
const viewMoreHandler = function () {
  const viewMoreButtons = document.querySelectorAll('.view-more-btn');
  viewMoreButtons.forEach((vmButton) => {
    vmButton.addEventListener('click', function (event) {
      event.preventDefault();
      fetchNextDataRows();
    });
  });
};
viewMoreHandler();

const riskScale = {
  Low: -45,
  'Moderately Low': -22.5,
  Moderate: 0,
  'Moderately High': 22.5,
  High: 45,
  'Very High': 67.5,
};

document.addEventListener('DOMContentLoaded', function () {
  const gauges = document.querySelectorAll('.cmp-gauge');
  const riskTexts = document.querySelectorAll('.risk-text');

  gauges.forEach((gauge, index) => {
    const riskValue = gauge.getAttribute('data-risk');

    if (riskValue === 'Low' || riskValue === 'Moderately Low') {
      riskTexts[index].style.color = 'green';
    } else if (riskValue === 'Moderate' || riskValue === 'Moderately High') {
      riskTexts[index].style.color = 'orange';
    } else if (riskValue === 'High' || riskValue === 'Very High') {
      riskTexts[index].style.color = '#C43A4B';
    }

    const needle = gauge.querySelector('.needle');
    const rotationDegree = riskScale[riskValue] || 0;
    needle.style.transform = `rotate(${rotationDegree}deg)`;
    needle.style.transition = 'transform 0.5s ease';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document
    .getElementById('best-performer-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/best-performing-mutual-funds';
    });

  document
    .getElementById('index-fund-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/index-funds';
    });

  document
    .getElementById('wealth-builder-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/wealth-builder-funds';
    });

  document
    .getElementById('high-risk-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/high-return-mutual-funds';
    });

  document.getElementById('nfo-card')?.addEventListener('click', function () {
    window.location.href = '/mutual-funds/nfo';
  });

  document
    .getElementById('tax-savers-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/elss-funds';
    });

  function getCellValue(row, columnIndex) {
    const cell = row.cells[columnIndex];
    if (!cell) return 0;
    const text = cell.textContent.trim();
    let value = parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    if (text.includes('Cr')) {
      value *= 10000000;
    }
    return value;
  }

  function sortTable(columnIndex, button) {
    const tableBody = document.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    if (rows.length === 1 && rows[0].textContent.includes('No Schemes')) {
      return;
    }
    const isAscending = button.dataset.order === 'asc';
    button.dataset.order = isAscending ? 'desc' : 'asc';
    rows.sort((rowA, rowB) => {
      const valA = getCellValue(rowA, columnIndex);
      const valB = getCellValue(rowB, columnIndex);
      return isAscending ? valA - valB : valB - valA;
    });
    rows.forEach((row) => tableBody.appendChild(row));
  }
  document
    .getElementById('returns-filter-arrow')
    ?.addEventListener('click', function () {
      sortTable(1, this);
    });
  document
    .getElementById('invest-filter-arrow')
    ?.addEventListener('click', function () {
      sortTable(2, this);
    });
  document
    .getElementById('aum-filter-arrow')
    ?.addEventListener('click', function () {
      sortTable(3, this);
    });
});

function createSlug(value) {
  return value
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}
const categoryFilter = {
  'wealth-builder-funds': {
    category: 'Large Cap Fund|Multi Cap Fund',
    typename: 'Equity',
  },
  'elss-funds': {
    category: 'ELSS',
    typename: 'Equity',
  },
  'high-return-mutual-funds': {
    category: 'Small Cap Fund|Multi Cap Fund',
    typename: 'Equity',
  },
};

function performSearch(searchTerm, mfcocode, categoryKey, resultsContainer) {
  searchTerm = searchTerm?.toLowerCase().trim() || '';
  const { category, typename } = categoryFilter[categoryKey] || {};

  const apiUrl = `${window._Torus.BFF_BASE_URL}/schemes/sitemap?${category ? `&Category=${category}` : ''}${typename ? `&Typename=${typename}` : ''}&pagination=1&sortby=1YEAR&orderby=desc&pageSize=20${
    mfcocode ? `&mf_cocode=${mfcocode}` : ''
  }`;

  fetch(apiUrl)
    .then((response) => response.json())
    .then((data) => {
      resultsContainer.innerHTML = '';

      if (data.data && data.data.length > 0) {
        let filteredResults = data.data.filter((item) =>
          item.schName.toLowerCase().includes(searchTerm),
        );

        filteredResults.forEach((item) => {
          if (item.schName && item.modified_schName) {
            const resultItem = document.createElement('a');
            resultItem.classList.add('result-item');
            resultItem.textContent = item.schName;
            resultItem.href = `${window.location.origin}/mutual-funds/${createSlug(item.modified_schName)}`;
            resultItem.target = '_blank';

            resultItem.addEventListener('click', (event) => {
              event.preventDefault();
              window.location.href = resultItem.href;
            });

            resultsContainer.appendChild(resultItem);
          }
        });

        resultsContainer.style.display =
          filteredResults.length > 0 ? 'block' : 'none';
      } else {
        resultsContainer.innerHTML = '<p>No results found</p>';
        resultsContainer.style.display = 'block';
      }
    })
    .catch((error) => {
      console.error('Error fetching search results:', error);
    });
}

function filterSectors(inputElement, mfcocode, resultsContainer, categoryKey) {
  const searchTerm = inputElement.value.trim().toLowerCase();

  if (searchTerm !== '') {
    performSearch(searchTerm, mfcocode, categoryKey, resultsContainer);
  } else {
    resultsContainer.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const mfcocode =
    document.getElementById('co_code-data')?.getAttribute('data-cocode') || '';

  const subpath =
    document.querySelector('.tabs-container')?.getAttribute('data-category') ||
    '';
  const categoryKey = createSlug(subpath);

  const webSearchInput = document.getElementById('webSearchInput');
  const mobileSearchInput = document.getElementById('mobileSearchInput');
  const webResultsContainer = document.getElementById('websearchResults');
  const mobileResultsContainer = document.getElementById('mobilesearchResults');

  if (webSearchInput) {
    let webSearchTimeoutId;
    webSearchInput.addEventListener('input', function () {
      clearTimeout(webSearchTimeoutId);
      webSearchTimeoutId = setTimeout(() => {
        filterSectors(
          webSearchInput,
          mfcocode,
          webResultsContainer,
          categoryKey,
        );
      }, 100);
    });
  }

  if (mobileSearchInput) {
    let mobileSearchTimeoutId;
    mobileSearchInput.addEventListener('input', function () {
      clearTimeout(mobileSearchTimeoutId);
      mobileSearchTimeoutId = setTimeout(() => {
        filterSectors(
          mobileSearchInput,
          mfcocode,
          mobileResultsContainer,
          categoryKey,
        );
      }, 100);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target.className === 'mf-search-icon') return;

    const isClickInsideWeb =
      webSearchInput && webSearchInput.contains(event.target);
    const isClickInsideMobile =
      mobileSearchInput && mobileSearchInput.contains(event.target);
    const isClickInsideWebResults =
      webResultsContainer && webResultsContainer.contains(event.target);
    const isClickInsideMobileResults =
      mobileResultsContainer && mobileResultsContainer.contains(event.target);

    if (!isClickInsideWeb && !isClickInsideWebResults && webResultsContainer) {
      webResultsContainer.style.display = 'none';
      webSearchInput.value = '';
    }

    if (
      !isClickInsideMobile &&
      !isClickInsideMobileResults &&
      mobileResultsContainer
    ) {
      mobileResultsContainer.style.display = 'none';
      mobileSearchInput.value = '';
    }
  });
});
